import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'

export default function useProcessEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router, route } = useRouter()
  const { getItemsAggregate, updateItem } = useLambda()
  const item = ref(null)
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id) }
  const collection = 'process'

  const show = async () => {
    isSubmitting.value = true

    try {
      const pipeline = [
        { $match: query },
        { $lookup: { from: 'metadata', localField: 'metadata', foreignField: '_id', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ], as: 'metadataData' } },
        { $lookup: { from: 'location', localField: 'locations', foreignField: '_id', pipeline: [ { $lookup: { from: 'physical_location', localField: 'physical_location', foreignField: '_id', as: 'physical_location', pipeline: [ { $project: { name: 1 } }, { $addFields: { _id: { $toString: "$_id" } } } ] } }, { $project: { location: 1, physical_location: 1 } }, { $addFields: { _id: { $toString: "$_id" }, physical_location: { $arrayElemAt: ["$physical_location", 0] } } } ], as: 'locations' } },
      ]
    
      const items = await getItemsAggregate({ collection, pipeline })
      if (!items?.[0]) throw new Error('Item not found')

      items[0].metadata = items[0].metadataData?.map(({ name, _id }) => ({ title: i18n.t(`metadata.${name}`), value: _id })) || []
      items[0].locations = items[0].locations?.map(({ location, _id, physical_location }) => ({ title: `${location}${physical_location?.name ? `  - ${physical_location.name}` : ''}`, value: _id, physical_location: physical_location?._id })) || []
      item.value = items[0]
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.data_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async payload => {
    isSubmitting.value = true

    payload.metadata = payload.metadata?.map(e => oid(e)) || []
    payload.locations = payload.locations?.map(e => oid(e)) || []

    try {
      const action = { $set: payload }

      await updateItem({ collection, query, action })

      showSuccessMessage(i18n.t('message.process_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.process_update_error'))
    } finally {
      router.push({ name: 'organization-process-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    item,
    isSubmitting,
  }
}
